<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-9 col-sm-12 col-12 no-gutters">
    <form [formGroup]="intelexSupplierAuditForm" class="col-xl-9 col-md-9 col-sm-12 col-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal"><strong>Application Description</strong>
      </h6>
      <div class="col-12 text-normal mb-3">
        The Intelex Supplier Audit platform streamlines audit-related tasks and drive results. 
        This solution enables the GSC Sourcing Organization to supplier audit data so maintain a 100% audit-ready archive of centralize data to be compliant with ISO Audit requirements. 
        Mobile capabilities allows SQEs from across world to standardize audit checklist, 
        preform real-time audits, access information, and interact directly with suppliers on findings.
      </div>
      <h6 class="col-12 text-normal"><strong>Registration Question</strong>
      </h6>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          <span>
            Request Type
            <span style="color: red;">*</span>
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="reqType" placeholder="Select Request Type?">
            <mat-option *ngFor="let item of types" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Company Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="supCompany" name="supCompany" matInput #supCompany placeholder="" maxlength="50">
          <mat-hint align="end">{{supCompany.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Contact Full Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="supContactName" name="supContactName" matInput #supContactName placeholder="" maxlength="50">
          <mat-hint align="end">{{supContactName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Contact SSO ID
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="supContactSso" name="supContactSso" matInput #supContactSso placeholder="" maxlength="50">
          <mat-hint align="end">{{supContactSso.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Contact Email
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="supEmail" name="supEmail" matInput #supEmail placeholder="" maxlength="50">
          <mat-hint align="end">{{supEmail.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>

      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Business
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="business" placeholder="Select Business"
            (selectionChange)="selectBusiness($event)">
            <mat-option *ngFor="let item of businesses" [value]="item">
              {{item?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">GSL Number
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="gslNumber" name="gslNumber" matInput #gslNumber placeholder="" maxlength="50">
          <mat-hint align="end">{{gslNumber.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Site Code
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="siteCode" name="siteCode" matInput #siteCode placeholder="" maxlength="50">
          <mat-hint align="end">{{siteCode.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">SQE Name/SSO
          <span style="color: red;">*</span>
        </div>
        <div class="col-12 justify-content-center text-normal">
          <mat-form-field floatLabel="never" appearance="outline" class="w-100">
            <input formControlName="sqeName" name="sqeName" matInput #sqeName maxlength="50" numbersOnly readonly>
            <mat-icon matSuffix (click)="searchSSO($event)" style="cursor: pointer;">search</mat-icon>
            <mat-hint align="end">{{sqeName.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Job Title
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="jobTitle" name="jobTitle" matInput #jobTitle placeholder="" maxlength="50">
          <mat-hint align="end">{{jobTitle.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Phone Number
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="phone" name="phone" matInput #phone placeholder="" maxlength="50">
          <mat-hint align="end">{{phone.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Extension
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="extension" name="extension" matInput #extension placeholder="" maxlength="50">
          <mat-hint align="end">{{extension.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>

      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Please add any additional details needed to support your request
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <textarea formControlName="detail" name="detail" matInput #detail placeholder="" rows="5"
            cols="50" id="detail" maxlength="512">
          </textarea>
          <mat-hint align="end">{{detail.value.length}} / 512</mat-hint>
        </mat-form-field>
      </div>

      <div class="row no-gutters col-12 d-flex align-items-center justify-content-center py-4">
        <button class="btn btn-primary btn-vernova button col-xl-5 col-md-6 col-sm-12 col-12 text-normal" style="font-size: 18px;"
          (click)="submitIntelexSupplierAuditForm()">
          <span>
            Request Access
          </span>
        </button>
      </div>
    </form>
  </div>
  <div class="col-sm-12 col-md-3 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>
      <div class="col-12 mt-3 p-0 text-normal">
        Intelex Supplier Audit Support (<a href="mailto:Intelex_Supplier_Audit_Support@ge.com" style="word-wrap: break-word;" class="text-highlight">Intelex_Supplier_Audit_Support@ge.com</a>)
      </div>
    </div>
    <hr>
    <div class="d-flex col-12 no-gutters">
      <h6><strong class="mt-3 text-lable">Request Created</strong></h6>
      <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
        <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;"
        (click)="getListTicket($event)"></i>
      </div>
    </div>
    <div class="col-12 border-box no-gutters d-flex align-items-center justify-content-center">
      <div class="col-11 no-gutters">
        <div class="col-12 text-normal no-gutters" *ngFor="let item of request; let first = first; let last = last">
          <div class="pt-3 col-12" *ngIf="first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="col-12" *ngIf="!first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="py-2">
            <div>
              Request ID number:
            </div>
            <div>{{item?.number}}</div>
            <!-- <a href="{{item?.requestUrl}}" target="_blank">
              {{item?.number}}
            </a> -->
          </div>
          <div class="pb-3" *ngIf="last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <div *ngIf="!last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>
  </div>
</div>